import { Space, Typography } from "antd";
import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
const { Title, Text } = Typography

interface PieChartProps {
    data: { name: string; value: number }[];
    colors?: string[];
}

const AnyalyticsPieChart: React.FC<PieChartProps> = ({ data, colors }) => {

    const COLORS = colors ?? ["#FF9F00", "#00BFFF", "#9ACD32", "#FF69B4"];

    const thousendSeperator = (value: number) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const calculateHighest = () => {
        let highest = data[0];
        data.forEach((ele) => {
            if (ele.value > highest.value) {
                highest = ele;
            }
        });
        return highest;
    }

    const calCulateTotal = () => {
        let total = 0;
        data.forEach((ele) => {
            total += ele.value;
        });
        return total;
    }

    const calculateLowest = () => {
        let lowest = data[0];
        data.forEach((ele) => {
            if (ele.value < lowest.value) {
                lowest = ele;
            }
        });
        return lowest;
    }

    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <PieChart width={400} height={400}>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={30}
                    outerRadius={120}
                    fill="#8884d8"
                    dataKey="value"
                    nameKey="name"
                    label
                >
                    {data.map((_, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip />
                <Legend />
            </PieChart>

            <div style={{ marginLeft: "30px" }}>
                <Space size={[30, 30]} direction="vertical" >
                    <Space direction="vertical">
                        <Title level={5}>Total Compensation</Title>
                        <Text>INR {thousendSeperator(calCulateTotal())}</Text>
                    </Space>
                    <Space direction="vertical">
                        <Title level={5}>Highest Compensation</Title>
                        <Text>{calculateHighest().name} (INR {thousendSeperator(calculateHighest().value)})</Text>
                    </Space>
                    <Space direction="vertical">
                        <Title level={5}>Lowest Compensation</Title>
                        <Text>{calculateLowest().name} (INR {thousendSeperator(calculateLowest().value)})</Text>
                    </Space>
                </Space>
            </div>
        </div>
    );
};

export default AnyalyticsPieChart;
